import { HTMLProps } from 'react';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import StubIcon from '@/public/assets/forecast-icons/stub/stub.svg';
import { AppConfig } from '@/utils/AppConfig';
import 'react-lazy-load-image-component/src/effects/blur.css';

/**
 * Base type same as module definition
 * @see typings.d.ts
 */
type ForecastIconProps = HTMLProps<HTMLImageElement> & {
  iconName: string;
  isDark?: boolean;
};

const ForecastIcon = ({ iconName, className, alt, isDark = false }: ForecastIconProps) => {
  const icon = isDark ? `n_${iconName}` : `d_${iconName}`;

  // У LazyLoadImage со свойством placeholder, img тег оборачивается в span, который в библиотеке отображается как inline-block.
  // Для наших нужд делаем его block элементом (свойство color оставил из оригинальных стилей) и
  // все основные className переносятся на него, а сам img тег просто занимает 100% ширины родителя
  return (
    <LazyLoadImage
      src={`${AppConfig.basePath}/assets/forecast-icons/${icon}.svg`}
      alt={alt}
      placeholder={<StubIcon className={className} />}
      effect="blur"
      className="w-full"
      wrapperClassName={className}
      wrapperProps={{ style: { display: 'block', color: 'transparent' } }}
    />
  );
};

export default ForecastIcon;
